import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { ArrowRight, ShieldCheck } from 'lucide-react';
export function CTASection() {
  return <section id="pricing" className="py-24 px-4 bg-navy-900 text-white text-center" data-id="element-17">
      <div className="max-w-4xl mx-auto" data-id="element-18">
        <FadeIn data-id="element-19">
          <h2 className="text-3xl md:text-5xl font-bold mb-6" data-id="element-20">
            Stop Ripping Off Your Mask. Start Sleeping.
          </h2>
          <p className="text-xl md:text-2xl text-blue-100 mb-12 max-w-2xl mx-auto" data-id="element-21">
            If you're tired of "just get used to it" advice—and you want a calm,
            step-by-step plan to get through the first month without quitting:
          </p>

          <div className="bg-navy-800 p-8 md:p-12 rounded-2xl border border-navy-700 max-w-2xl mx-auto shadow-2xl" data-id="element-22">
            <div className="mb-8" data-id="element-23">
              <div className="inline-flex items-center bg-teal-600 text-white text-sm font-bold px-4 py-1.5 rounded-full mb-5 uppercase tracking-wide" data-id="element-24">
                You save $22.64 — 78% off
              </div>

              <span className="block text-lg text-gray-300 uppercase tracking-widest font-semibold" data-id="element-25">
                One-Time Payment
              </span>

              <div className="flex items-center justify-center gap-4 mt-4" data-id="element-26">
                <span className="text-2xl text-gray-500 line-through font-medium" data-id="element-27">
                  $29
                </span>
                <span className="text-6xl font-bold text-white" data-id="element-28">$6.36</span>
              </div>

              <p className="mt-3 text-sm text-teal-400 font-medium" data-id="element-29">
                Launch price — same complete guide, all 7 printables included
              </p>
            </div>

            <a href="https://www.betterbysteps.com/cart/44196935958621:1" target="_blank" rel="noopener noreferrer" className="w-full bg-amber-500 hover:bg-amber-600 text-white text-xl font-bold py-5 px-8 rounded-lg shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 transition-all duration-200 flex items-center justify-center" data-id="element-30">
              Download CPAP Compliance Rescue
              <ArrowRight className="ml-2 h-6 w-6" data-id="element-31" />
            </a>

            <div className="mt-6 flex items-center justify-center text-sm text-gray-400" data-id="element-32">
              <ShieldCheck className="h-4 w-4 mr-2" data-id="element-33" />
              Secure 256-bit SSL Encrypted Checkout
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}